module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/121-new-zealand-15b178f15f312aac4c01dd6b87444b16.svg";